<header>
    <div class="container-fluid">
        <div class="d-flex">
            <div class="logo"><img src="assets/images/NSEICC.png"></div>
            <div class="d-flex justify-content-end userManual">
                <a href="" class="mb-0 contact" type="button" (click)="openUserManual()">
                    <div class="d-inline-flex">
                        User Manual<span class="caret"></span>
                    </div>
                </a>
            </div>
        </div>

    </div>
    <div class="seperator">
        <div class="col-lg-1 seperator1"></div>
        <div class="col-lg-2 seperator2"></div>
        <div class="col-lg-4 seperator3"></div>
        <div class="col-lg-5 seperator4"></div>
    </div>
</header>
<div class="col-lg-12">
    <div class="row login-slider">
        <div class="col-md-7 backgroundimg offset-sm-1">
            <div id="loginslider" class="carousel slide" data-ride="carousel">
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <h1>OTC Reporting Platform – NSEICC</h1>
                        <p>The NSEICC OTC Reporting Platform is a cutting-edge solution designed to enhance
                            transparency, improve compliance, and streamline the reporting of Over-the-Counter (OTC)
                            trades as per IFSCA guidelines. As a trusted platform, we provide market participants with a
                            seamless way to report transactions, ensuring adherence to regulatory guidelines and
                            industry best practices. </p>
                        <p>With increasing regulatory scrutiny and the need for accurate trade disclosures, our platform
                            serves as a reliable tool to maintain market integrity. By leveraging advanced technology,
                            we simplify the complexities of OTC trade reporting, ensuring that all transactions are
                            captured and reported efficiently.
                        </p>
                    </div>
                    <div class="carousel-item">
                        <h1>Why Choose NSEICC's OTC Reporting Platform?</h1>
                        <p>✅ Regulatory Compliance – Stay ahead of regulatory requirements with our secure and efficient
                            reporting system.</p>
                        <p>✅ Transparency & Integrity – Enhance market confidence through accurate and timely reporting.
                        </p>
                        <p>✅ Data Security – We prioritize the confidentiality and security of reported data</p>
                        <p>✅ User-Friendly Interface – Easily report and monitor details with our intuitive dashboard.
                        </p>
                    </div>
                    <div class="carousel-item">
                        <app-contact></app-contact>
                    </div>
                </div>
                <ol class="carousel-indicators">
                    <li data-target="#loginslider" data-slide-to="0" class="active"></li>
                    <li data-target="#loginslider" data-slide-to="1"></li>
                    <li data-target="#loginslider" data-slide-to="2"></li>
                </ol>
            </div>
        </div>
        <div class="col-md-4 form-section">
            <div class="login-inner-form">

                <router-outlet></router-outlet>
            </div>
        </div>

    </div>
    <div class="copyright">
        Best viewed with Chrome browser. Copyright © 2022 National Stock Exchange of India Ltd. All rights reserved
    </div>
</div>